import React  from 'react';

import moment from "moment";

import BackgroundImage from 'gatsby-background-image'
import Share from "../components/Share";
import { Link } from "gatsby"


const PostTile = ({ post, fields, ...props }) => {
  return <article className="blog-card">
          <div className="meta">
          
        <BackgroundImage
          Tag="span"
          fluid={post.cover.childImageSharp.fluid}
          className={"photo"}
        />
        <div className="details">
            
        <div className="category">
            {post.keywords && post.keywords.map((k, idx) => <Link key={idx} to={`/keywords/${k.replace(/ /g, "-").toLowerCase()}`}>{k}</Link>)}
        </div> 
          <span className="share">
            <span>Share</span>
            <Share
              socialConfig={{
                config: {
                  url: `${typeof(window) !== 'undefined' && document.location.href}/${fields.slug}`,
                  title: `${post.title}`
                }
              }}
            />
          </span>
        </div>
      </div>
      
      <div className="description">
        <Link to={fields.slug}>      
          <h1 className="card-title">{post.title}</h1>
        </Link>
      <h2>{moment(post.date).format("LL")} {"// by:"} <Link to={`/author/${post.author.replace(/ /g,"-").toLowerCase()}`}>{post.author}</Link></h2>
      <span className="mx-auto mt-2 mb-5 author ">{Math.round(fields.readingTime.words / 250)} min read</span>

        <Link to={fields.slug}>
            <p className="card-text">{post.description}</p>
        </Link>    
      </div>        
    </article>
}


export default PostTile;